export default __webpack_public_path__ + "static/media/illustration-insider.ea6ba7a1.svg";